import classNames from 'classnames';
import React from 'react';
import { s as styles } from '../image-viewer.rtlignore-a7a393e5.js';
import InPluginInput from '../InPluginInput.js';
import '../style-inject.es-e7b07dd7.js';

const EditorImageCaption = ({
  onCaptionChange,
  imageType,
  caption
}) => {
  if (!caption)
    return null;
  const isLinkImage = imageType === "link" || imageType === "anchor";
  const classes = classNames(styles.imageCaption, { [styles.link]: isLinkImage });
  return /* @__PURE__ */ React.createElement(InPluginInput, { className: classes, value: caption, onChange: onCaptionChange });
};

export { EditorImageCaption };
//# sourceMappingURL=editor-image-caption.js.map
